import React from "react";

const TableLoader = ({ message = "Loading data...", overlay = false }) => {
  if (overlay) {
    // Overlay mode - shows on top of existing data
    return (
      <div className="absolute inset-0 bg-white/80 backdrop-blur-sm flex flex-col items-center justify-center z-20">
        <div className="relative">
          <div className="inline-block w-10 h-10 border-4 border-gray-200 border-t-indigo-600 rounded-full animate-spin"></div>
          <div className="absolute top-0 left-0 inline-block w-10 h-10 border-4 border-transparent border-r-indigo-400 rounded-full animate-spin" style={{ animationDirection: 'reverse', animationDuration: '1s' }}></div>
        </div>
        <p className="mt-3 text-sm font-medium text-gray-600">{message}</p>
      </div>
    );
  }

  // Full mode - replaces the table content
  return (
    <div className="py-20 px-5">
      <div className="flex flex-col items-center justify-center text-center">
        <div className="relative">
          <div className="inline-block w-12 h-12 border-4 border-gray-200 border-t-indigo-600 rounded-full animate-spin"></div>
          <div className="absolute top-0 left-0 inline-block w-12 h-12 border-4 border-transparent border-r-indigo-400 rounded-full animate-spin" style={{ animationDirection: 'reverse', animationDuration: '1s' }}></div>
        </div>
        <p className="mt-4 text-sm font-medium text-gray-600">{message}</p>
        <p className="mt-1 text-xs text-gray-400">Please wait while we fetch the data</p>
      </div>
    </div>
  );
};

export default TableLoader;
